import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelope,
  faLocationDot
} from '@fortawesome/free-solid-svg-icons';

const ContactSection = styled.section`
  padding: 80px 0;
  background: var(--white);
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    color: var(--dark-color);
    margin-bottom: 20px;
    font-weight: 700;
  }

  p {
    font-size: 18px;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const ContactWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 50px;
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  overflow: hidden;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div`
  background: var(--gradient);
  padding: 40px;
  color: var(--white);

  @media (max-width: 968px) {
    padding: 30px;
  }
`;

const InfoTitle = styled.h3`
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 600;
`;

const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const InfoItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  font-size: 16px;

  svg {
    margin-right: 15px;
    font-size: 20px;
  }
`;

const ContactForm = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  background: var(--white);
  border-radius: var(--border-radius);
  overflow: hidden;
`;

const FormIframe = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 498px;
  border: none;
  border-radius: var(--border-radius);
  box-shadow: none;
  background: transparent;
  display: block;
`;

const Contact: React.FC = () => {
  React.useEffect(() => {
    // Load the GHL form script
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <ContactSection id="contact">
      <Container>
        <SectionTitle data-aos="fade-up">
          <h2>📞 Get in Touch</h2>
          <p>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </SectionTitle>
        <ContactWrapper data-aos="fade-up">
          <ContactInfo>
            <InfoTitle>Contact Information</InfoTitle>
            <InfoList>
              <InfoItem>
                <FontAwesomeIcon icon={faPhone} />
                +91 7940327195
              </InfoItem>
              <InfoItem>
                <FontAwesomeIcon icon={faEnvelope} />
                <span> <a href="mailto:info@theonetechnologies.com">info@theonetechnologies.com</a></span>
              </InfoItem>
              <InfoItem>
                <FontAwesomeIcon icon={faLocationDot} />
                B-801, The First,
                B/H Keshavbaug, Vastrapur,
                Ahmedabad, Gujarat 380015
              </InfoItem>
            </InfoList>
          </ContactInfo>
          <ContactForm>
            <FormIframe
              src="https://api.leadconnectorhq.com/widget/form/OekiirNrKF9Uge3EAebI"
              id="inline-OekiirNrKF9Uge3EAebI"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="WAGHL Contact Us"
              data-height="498"
              data-layout-iframe-id="inline-OekiirNrKF9Uge3EAebI"
              data-form-id="OekiirNrKF9Uge3EAebI"
              title="WAGHL Contact Us"
            />
          </ContactForm>
        </ContactWrapper>
      </Container>
    </ContactSection>
  );
};

export default Contact; 